var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTutor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400.00000000000006,
    height: 397,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 402,
    height: 399,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000123435403773781372700000010968587082042651779_",
    x: 105.336,
    y: 53.789,
    width: 118.625,
    height: 159.949
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094612429766436199000000010427729321135956871_",
    x1: 0.226307,
    y1: -0.181543,
    x2: 0.767669,
    y2: 1.121324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5B2A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1693,
    stopColor: "#4B2786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4267,
    stopColor: "#38247D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6972,
    stopColor: "#2E2379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2277"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101090154395486406760000010679221706530132613_",
    x1: 0.24998,
    y1: 0.066941,
    x2: 0.750042,
    y2: 0.933075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DF697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073679669538448038670000008265385035722506149_",
    x1: 0.000039,
    y1: 0.500196,
    x2: 1.000013,
    y2: 0.500196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5B2A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1693,
    stopColor: "#4B2786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4267,
    stopColor: "#38247D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6972,
    stopColor: "#2E2379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2277"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159470529546333518820000015909795543581589675_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123435403773781372700000010968587082042651779_",
    id: "svg_58",
    y: 0,
    x: -1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m278.263481,385.284002c1.154,-6.471 1.757,-13.134 1.757,-19.937c0,-62.286 -50.493,-112.78 -112.78,-112.78c-62.286,0 -112.78,50.493 -112.78,112.78c0,6.803 0.603,13.466 1.757,19.937l222.046,0z",
    fill: "#DCE8EF",
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071,-0.7071,0.7071,0.7071,-101.7513,149.9623) ",
    cx: 140.871545,
    cy: 135.822888,
    rx: 66.397,
    ry: 66.398,
    fill: "#DCE8EF",
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8947,-0.4467,0.4467,0.8947,-25.6123,173.1212) ",
    cx: 344.886384,
    cy: 78.691613,
    rx: 32.324,
    ry: 32.324,
    fill: "#DCE8EF",
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2096,-0.9778,0.9778,0.2096,6.8384,386.5441) ",
    cx: 285.192921,
    cy: 142.828078,
    rx: 7.258,
    ry: 7.258,
    fill: "#DCE8EF",
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.197481,
    cy: 344.108002,
    r: 14.36,
    fill: "#DCE8EF",
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.521481,397.174002l-361.53,0c-3.018,0 -5.488,-2.469 -5.488,-5.488l0,0c0,-3.018 2.469,-5.488 5.488,-5.488l361.529,0c3.018,0 5.488,2.47 5.488,5.488l0,0c0.001,3.018 -2.469,5.488 -5.487,5.488z",
    fill: "#DCE8EF",
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m348.937481,162.470002l-21.966,0l0,-27.227l21.966,0l0,27.227zm-19.966,-2l17.966,0l0,-23.227l-17.966,0l0,23.227z",
    fill: "#DCE8EF",
    id: "svg_12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.721481,
    y: 139.631002,
    width: 10.467,
    height: 2,
    fill: "#DCE8EF",
    id: "svg_15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.721481,
    y: 143.754002,
    width: 10.467,
    height: 2,
    fill: "#DCE8EF",
    id: "svg_17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.721481,
    y: 147.879002,
    width: 10.467,
    height: 2,
    fill: "#DCE8EF",
    id: "svg_19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.721481,
    y: 152.002002,
    width: 5.7,
    height: 2,
    fill: "#DCE8EF",
    id: "svg_21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svg_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m264.377481,89.966002l-24.264,0l0,-16.04l24.264,0l0,16.04zm-22.264,-2l20.264,0l0,-12.04l-20.264,0l0,12.04z",
    fill: "#DCE8EF",
    id: "svg_24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_25"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "252.2454948425293,85.07299423217773 240.4904899597168,75.70901107788086 241.73649215698242,74.14400100708008 252.2454948425293,82.5160026550293 262.75446701049805,74.14400100708008 264.0004692077637,75.70901107788086 ",
    fill: "#DCE8EF",
    id: "svg_26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m212.831481,62.664002c-7.254,0 -13.155,-5.902 -13.155,-13.156s5.901,-13.155 13.155,-13.155c7.254,0 13.156,5.901 13.156,13.155s-5.902,13.156 -13.156,13.156zm0,-24.311c-6.151,0 -11.155,5.004 -11.155,11.155c0,6.151 5.004,11.156 11.155,11.156s11.156,-5.004 11.156,-11.156c0,-6.151 -5.004,-11.155 -11.156,-11.155z",
    fill: "#DCE8EF",
    id: "svg_29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_30"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "210.06748580932617,54.86899948120117 208.61448287963867,53.494998931884766 212.3754997253418,49.5160026550293 212.3754997253418,41.064998626708984 214.3754997253418,41.064998626708984 214.3754997253418,50.3120002746582 ",
    fill: "#DCE8EF",
    id: "svg_31"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m326.474481,97.985002l-11.495,0c-1.528,0 -2.771,-1.244 -2.771,-2.772l0,-2.648l-6.674,3.853l0,-13.904l6.674,3.853l0,-2.648c0,-1.528 1.243,-2.772 2.771,-2.772l11.495,0c1.528,0 2.771,1.244 2.771,2.772l0,11.495c0,1.528 -1.243,2.771 -2.771,2.771zm-12.267,-8.154l0,5.383c0,0.426 0.346,0.772 0.771,0.772l11.495,0c0.426,0 0.771,-0.346 0.771,-0.772l0,-11.495c0,-0.426 -0.346,-0.772 -0.771,-0.772l-11.495,0c-0.426,0 -0.771,0.346 -0.771,0.772l0,6.112zm-6.674,-3.853l0,6.977l6.042,-3.488l-6.042,-3.489z",
    fill: "#F9FBFC",
    id: "svg_33"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255.767481,18.284002l-31.801,0c-3.407,0 -6.169,-2.762 -6.169,-6.169l0,0c0,-3.407 2.762,-6.169 6.169,-6.169l31.801,0c3.407,0 6.168,2.762 6.168,6.169l0,0c0.001,3.407 -2.761,6.169 -6.168,6.169z",
    fill: "#DCE8EF",
    id: "svg_34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.275481,44.192002l-17.425,0c-3.407,0 -6.169,-2.762 -6.169,-6.168l0,0c0,-3.407 2.762,-6.168 6.169,-6.168l17.425,0c3.407,0 6.169,2.762 6.169,6.168l0,0c0,3.406 -2.762,6.168 -6.169,6.168z",
    fill: "#DCE8EF",
    id: "svg_35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.117481,293.770002l-17.425,0c-3.407,0 -6.169,-2.762 -6.169,-6.169l0,0c0,-3.407 2.762,-6.169 6.169,-6.169l17.425,0c3.407,0 6.169,2.762 6.169,6.169l0,0c0,3.408 -2.762,6.169 -6.169,6.169z",
    fill: "#F9FBFC",
    id: "svg_36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.441481,115.842002l-17.426,0c-3.407,0 -6.169,-2.762 -6.169,-6.169l0,0c0,-3.407 2.762,-6.169 6.169,-6.169l17.425,0c3.407,0 6.169,2.762 6.169,6.169l0,0c0,3.407 -2.762,6.169 -6.168,6.169z",
    fill: "#F9FBFC",
    id: "svg_37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.245481,263.835002l-21.797,0c-1.996,0 -3.615,-1.618 -3.615,-3.615l0,0c0,-1.996 1.618,-3.615 3.615,-3.615l21.797,0c1.996,0 3.615,1.618 3.615,3.615l0,0c0,1.996 -1.619,3.615 -3.615,3.615z",
    fill: "#F9FBFC",
    id: "svg_38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m332.412481,383.152002c-0.126,0.441 -0.158,0.913 -0.158,1.386c0,3.936 3.212,7.148 7.18,7.148s7.18,-3.212 7.18,-7.148c0,-3.968 -3.212,-7.18 -7.18,-7.18c-0.504,0 -0.976,0.063 -1.449,0.157l-0.032,0c-2.801,0.599 -5.006,2.803 -5.541,5.637z",
    fill: "#000000",
    id: "svg_43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.503481,377.358002c-3.936,0 -7.148,3.212 -7.148,7.18c0,3.936 3.212,7.148 7.148,7.148c3.968,0 7.18,-3.212 7.18,-7.148c0,-0.472 -0.031,-0.945 -0.158,-1.386c-0.535,-2.834 -2.74,-5.038 -5.542,-5.637l-0.031,0c-0.473,-0.094 -0.945,-0.157 -1.449,-0.157z",
    fill: "#000000",
    id: "svg_44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.674481,375.594002l-3.968,0l31.706,7.558c0.535,-2.834 2.74,-5.038 5.542,-5.637l-33.28,-7.967l0,6.046z",
    fill: "#CFD1D2",
    id: "svg_45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.452481,369.485002l-33.469,8.03c2.803,0.598 5.007,2.803 5.542,5.637l31.737,-7.558l-3.81,0l0,-6.109z",
    fill: "#CFD1D2",
    id: "svg_46"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "295.8094902038574,374.91201400756836 295.8094902038574,379.5280113220215 298.6884880065918,379.5280113220215 303.1614799499512,379.5280113220215 306.15949630737305,379.5280113220215 306.15949630737305,374.95998764038086 306.15949630737305,294.17101669311523 295.8094902038574,294.17101669311523 ",
    fill: "#CFD1D2",
    id: "svg_47"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.8094902038574,298.2789878845215 295.8094902038574,298.59399032592773 298.6884880065918,298.59399032592773 303.1614799499512,298.59399032592773 306.15949630737305,298.59399032592773 306.15949630737305,298.28200912475586 306.15949630737305,294.17101669311523 295.8094902038574,294.17101669311523 ",
    fill: "#BABCBE",
    id: "svg_48"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.4334831237793,284.4880027770996 289.4334831237793,294.17101669311523 295.8094902038574,294.17101669311523 306.15949630737305,294.17101669311523 312.5594902038574,294.17101669311523 312.5594902038574,284.4880027770996 ",
    fill: "#000000",
    id: "svg_49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.750481,
    y: 244.518002,
    width: 10.707,
    height: 28.43,
    fill: "#CFD1D2",
    id: "svg_50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.882481,276.755002l0,3.926c0,2.094 1.713,3.807 3.807,3.807l25.744,0l23.127,0l25.744,0c2.094,0 3.807,-1.713 3.807,-3.807l0,-3.926c0,-2.117 -1.713,-3.807 -3.807,-3.807l-14.847,0l-10.707,0l-49.061,0c-2.094,0 -3.807,1.69 -3.807,3.807z",
    fill: "#626466",
    id: "svg_51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.027481,210.994002l0,26.743c0,3.759 3.046,6.781 6.781,6.781l14.942,0l10.707,0l13.514,0c3.759,0 6.781,-3.022 6.781,-6.781l0,-26.743c0,-3.759 -3.022,-6.781 -6.781,-6.781l-39.163,0c-3.736,0 -6.781,3.022 -6.781,6.781z",
    fill: "#626466",
    id: "svg_52"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 67.905481,
    y: 1.188002,
    width: 121,
    height: 162.326,
    fill: "#38bff2",
    id: "svg_55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.717481,2.376002l0,159.949l-118.625,0l0,-159.949l118.625,0m2.376,-2.376l-2.376,0l-118.625,0l-2.376,0l0,2.376l0,159.949l0,2.376l2.376,0l118.625,0l2.376,0l0,-2.376l0,-159.949l0,-2.376l0,0z",
    fill: "#38bff2",
    id: "svg_56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.479481,38.016002c0.808,-2.091 1.235,-4.324 1.235,-6.676c0,-0.76 -0.551,-3.1 -0.647,-3.836c1.212,-0.903 2.737,-0.416 3.403,-1.699c0.404,1.117 0.808,2.257 1.212,3.374c0.475,1.283 0.927,2.59 1.045,3.944c0.19,2.067 -0.499,4.205 -1.829,5.773c-0.808,0.95 -1.829,1.711 -2.685,2.59c-0.879,0.903 -1.616,2.019 -1.663,3.255c-0.024,0.831 0.261,1.639 0.428,2.447c0.451,2.494 -0.57,5.322 -2.756,6.581c-2.21,1.283 -5.298,0.998 -6.89,2.97c-0.713,0.879 -0.95,2.043 -1.544,3.017c-0.594,0.927 -1.544,1.592 -2.59,1.901c-2.138,-1.259 -4.728,-2.423 -7.793,-3.54c-0.879,-0.333 -1.806,-0.665 -2.78,-0.974c0.689,-1.711 1.378,-3.445 1.378,-3.445s6.225,1.568 7.579,0.832c1.33,-0.76 11.073,-9.106 14.872,-16.512l0.025,0l0,-0.002z",
    fill: "#494949",
    id: "svg_60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.625481,29.070002c0.166,0.713 0.09,1.527 0.09,2.27c0,3.265 -0.698,7.393 -2.868,9.959c-0.923,1.092 -1.593,1.857 -2.19,3.156c-0.562,1.224 -1.03,2.838 -1.883,3.88c-2.061,2.518 -7.625,5.872 -10.356,7.433c-1.354,0.736 -6.413,-2.071 -6.413,-2.071s-0.689,1.734 -1.378,3.445l-5.464,4.728c-2.358,-2.196 -6.061,-4.556 -6.363,-8.015c-0.158,-1.81 0.34,-3.606 0.855,-5.348c1.135,-3.842 2.371,-7.653 3.669,-11.443c0.339,-0.991 0.69,-1.995 1.294,-2.851c0.73,-1.035 1.787,-1.791 2.87,-2.446c7.182,-4.343 15.99,-4.935 24.38,-4.673c0.949,0.029 1.942,0.081 2.757,0.566c0.588,0.35 0.869,0.848 1,1.41z",
    fill: "#FFC8AF",
    id: "svg_61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.162481,61.869002c-3.573,-3.158 -5.915,-6.47 -6.222,-10.095l-3.994,0.737c0,0 0.044,4.493 1.653,7.774c1.61,3.282 2.338,4.767 2.338,4.767l6.225,-3.183z",
    fill: "#E8B83F",
    id: "svg_62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.337481,137.629002c0,0 2.123,31.111 1.564,32.258c-0.559,1.147 41.726,1.647 41.726,1.647l3.82,-31.146l-47.11,-2.759z",
    fill: "url(#SVGID_00000094612429766436199000000010427729321135956871_)",
    id: "svg_63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.113481,90.521002l-4.134,49.868l-3.54,0c1.402,-13.257 2.685,-34.069 3.492,-44.997c2.495,-2.923 4.182,-4.871 4.182,-4.871z",
    fill: "#E8BA70",
    id: "svg_64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.170481,136.064002c3.35,7.056 10.026,7.935 10.026,7.935c-2.922,0.95 -5.512,1.521 -7.507,1.568c-7.579,0.166 -15.823,-23.52 -19.125,-40.103c1.283,-2.661 2.328,-5.155 2.257,-6.343c-0.095,-1.592 -0.38,-10.216 -0.57,-16.939c0,0 11.546,46.85 14.919,53.882z",
    fill: "#E8BA70",
    id: "svg_65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.26448,114.041c-0.737,1.877 -2.661,13.59 -2.97,26.347l-41.315,0l4.134,-49.868c0,0 -1.687,1.948 -4.181,4.87c-6.771,7.935 -19.624,23.093 -20.883,25.611c-1.449,2.922 -1.33067,-7.60377 -1.75767,3.89523c-2.78,-1.592 5.01293,-10.07876 -0.35607,-7.86876c-1.734,-21.762 0.87897,-9.61161 2.61397,-13.72161c2.637,-6.248 3.27777,-27.20686 12.78077,-40.22686c2.376,-3.231 4.585,-5.749 6.89,-7.579c2.708,-2.186 5.559,-3.469 8.909,-4.015c1.924,0.048 3.777,0.689 5.345,1.782c1.117,0.808 2.067,1.829 3.065,2.78c1.924,1.829 4.181,3.421 6.771,4.039c1.354,0.333 1.074,-6.857 2.428,-7.214l4.201,12.179l6.224,-3.184l5.108,4.395l3.136,-8.149c3.065,1.117 5.654,2.281 7.793,3.54c4.538,2.637 7.199,5.654 8.529,9.408c0,0.024 0.024,0.024 0.024,0.048c2.875,11.499 12.99981,49.54908 14.967,52.172l30.30026,-8.73787c-23.72081,6.74766 -30.39131,11.58373 -8.3444,11.47054c-7.389,4.181 -11.47986,14.46833 -22.47986,17.98433c0,0 -6.676,-0.879 -10.026,-7.935c-3.374,-7.032 -14.92,-53.883 -14.92,-53.883c0.19,6.723 0.475,15.348 0.57,16.939l-6.556,14.922z",
    fill: "#FBD15B",
    id: "svg_66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.21648,108.137c0.453,-0.88 0.913,-1.784 1.348,-2.672c3.303,16.583 11.546,40.269 19.125,40.103c1.996,-0.048 4.585,-0.618 7.507,-1.568c10.068,-3.218 13.72332,-4.49656 21.71832,-8.95256c0.89624,-6.13979 -0.76924,-10.95333 -0.13735,-18.46084l-21.05797,6.6974c0,0 -12.093,-40.673 -14.967,-52.172c0,-0.024 -0.024,-0.024 -0.024,-0.048c-1.331,-3.754 -3.991,-6.771 -8.529,-9.408c-0.535,-0.315 -1.097,-0.624 -1.688,-0.927l-5.064,41.327c0,-0.002 0.698,2.402 1.769,6.081z",
    fill: "#F0F5F7",
    id: "svg_67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.170481,136.064002c3.35,7.056 10.026,7.935 10.026,7.935c-2.922,0.95 -5.512,1.521 -7.507,1.568c-7.579,0.166 -15.823,-23.52 -19.125,-40.103c1.283,-2.661 2.328,-5.155 2.257,-6.343c-0.095,-1.592 -0.38,-10.216 -0.57,-16.939c0,0 11.546,46.85 14.919,53.882z",
    fill: "#DCE8EF",
    id: "svg_68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.61648,61.421l0,0c-0.568,-5.243 -1.223,-7.537 -0.732,-9.503c0.492,-1.966 -3.604,2.13 -3.604,2.13l-1.446,1.899l-8.712,-6.691l-10.136,4.069c-4.377,1.757 -8.116,4.781 -10.744,8.698c-9.548,14.229 -16.03788,23.19066 -16.89988,27.15266c-1.086,4.993 -0.71719,-11.08989 1.57786,37.10628c4.58801,-0.983 0.31842,-45.73652 -0.00944,-10.32709s2.61846,7.51715 3.93246,5.76215c1.314,-1.755 19.069,-25.13 19.069,-25.13l-5.071,67.42l29.777,-0.668c0.001,-0.001 4.61,-86.844 2.998,-101.918z",
    fill: "#F0F5F7",
    id: "svg_69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.310481,28.337002c-1.231,0.436 -2.566,0.591 -3.879,0.664c-3.879,0.216 -7.347,0.61 -10.597,2.993c-1.723,1.263 -3.236,2.928 -5.27,3.582c-0.807,0.26 -1.742,0.393 -2.26,1.064c-0.624,0.81 -0.338,2.021 -0.819,2.923c-0.885,1.657 -3.746,1.379 -4.547,3.079c-0.445,0.944 -0.026,2.117 -0.443,3.074c-0.373,0.856 -1.315,1.31 -2.219,1.548c-0.903,0.238 -1.864,0.341 -2.669,0.814c-1.804,1.059 -2.265,3.601 -4.023,4.733c-1.094,0.704 -2.427,0.357 -3.493,0.943c-1.084,0.595 -1.531,1.967 -2.382,2.795c-1.574,1.531 -4.248,0.942 -6.074,-0.277c-3.1,-2.069 -5.502,-4.687 -9.508,-4.786c-3.35,0.546 -5.822,1.708 -9.258,3.365c-1.552,-2.425 -0.809,-5.565 1.244,-7.553c1.057,-1.023 2.363,-1.742 3.559,-2.599c0.486,-0.348 0.969,-0.737 1.25,-1.265c0.473,-0.887 0.293,-1.996 0.681,-2.923c0.53,-1.265 1.955,-1.875 3.277,-2.243c1.321,-0.368 2.762,-0.666 3.699,-1.667c1.548,-1.653 1.007,-4.369 2.004,-6.403c0.912,-1.859 2.978,-2.867 4.993,-3.343c1.658,-0.391 3.715,-0.792 4.21,-2.423c0.179,-0.59 0.095,-1.234 0.265,-1.826c0.484,-1.69 2.619,-2.158 3.958,-3.297c1.418,-1.207 1.896,-3.155 2.796,-4.785c3.507,-6.351 13.893,-7.322 20.275,-6.23c5.01,0.858 9.756,3.277 13.408,6.811c3.112,3.01 8.636,9.687 2.882,12.765c-0.34,0.184 -0.695,0.338 -1.06,0.467z",
    fill: "#4b4a4c",
    id: "svg_70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.406481,58.115002l-3.136,8.149l-5.108,-4.395l5.464,-4.728c0.975,0.309 1.901,0.642 2.78,0.974z",
    fill: "#E8B83F",
    id: "svg_71"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m142.684481,37.486002c-0.231,1.099 0.472,2.177 1.57,2.408c1.099,0.231 2.177,-0.472 2.408,-1.57c0.231,-1.098 -0.472,-2.177 -1.57,-2.408c-1.099,-0.231 -2.177,0.472 -2.408,1.57z",
    fill: "#112B46",
    id: "svg_74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.131481,42.149002c-0.203,0.963 0.413,1.908 1.376,2.111c0.963,0.203 1.908,-0.413 2.111,-1.376c0.203,-0.963 -0.413,-1.908 -1.376,-2.111c-0.963,-0.204 -1.908,0.413 -2.111,1.376z",
    fill: "#112B46",
    id: "svg_75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.176481,46.814002c0,0 -2.298,-1.811 -2.73,-1.944c-0.433,-0.133 -0.116,0.747 0.806,1.539c0.922,0.792 1.924,0.405 1.924,0.405z",
    fill: "#F4B298",
    id: "svg_76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.751481,51.423002c0,0 -1.554,-1.234 -1.84,-1.305c-0.286,-0.071 -0.199,0.771 0.426,1.317c0.624,0.546 1.414,-0.012 1.414,-0.012z",
    fill: "#F4B298",
    id: "svg_77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.400481,32.979002c0,0 3.79,2.814 4.493,3.008c0.704,0.194 0.151,-1.21 -1.372,-2.444c-1.523,-1.235 -3.121,-0.564 -3.121,-0.564z",
    fill: "#56548C",
    id: "svg_78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.967481,41.431002c0,0 -3.486,-1.984 -3.827,-2.467c-0.342,-0.483 1.092,-0.541 2.59,0.221c1.497,0.76 1.237,2.246 1.237,2.246z",
    fill: "#56548C",
    id: "svg_79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.673481,50.008002c0,0 -2.95,-1.598 -5.689,-4.586c0,0 -1.059,1.252 -0.639,2.523c0.419,1.272 2.516,3.039 3.91,3.18c1.393,0.142 2.418,-1.117 2.418,-1.117z",
    fill: "#EC827D",
    id: "svg_80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.984481,45.422002c2.739,2.988 5.689,4.586 5.689,4.586s-0.143,0.174 -0.392,0.385c-1.815,-0.772 -3.897,-2.125 -5.714,-4.304c0.199,-0.401 0.417,-0.667 0.417,-0.667z",
    fill: "#F9FBFC",
    id: "svg_81"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m113.741481,59.127002l-2.393,11.715l4.915,5.325l-3.768,5.161l2.785,18.924c0,0 -4.014,-18.76 -3.932,-19.006c0.082,-0.246 3.605,-5.079 3.605,-5.079l-5.161,-5.161l3.949,-11.879z",
    fill: "#C3D3DD",
    id: "svg_83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.406481,58.115002c0.321,14.119 -1.318,31.487 -2.137,40.335c-0.819,8.848 -3.932,65.866 -3.932,65.866l10.227,0c0,0 -0.068,-54.602 1.161,-58.411c1.229,-3.809 2.703,-6.144 2.826,-8.725c0.123,-2.581 -2.041,-36.452 -2.041,-36.452l-6.104,-2.613z",
    fill: "#F0F5F7",
    id: "svg_84"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.51247787475586,61.20399856567383 142.01548385620117,73.29899978637695 138.4474754333496,77.6410026550293 140.8814811706543,82.18200302124023 136.99047470092773,101.72700119018555 142.01548385620117,82.35100936889648 139.50248336791992,77.47700119018555 143.1344871520996,73.54500198364258 ",
    fill: "#C3D3DD",
    id: "svg_85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.986481,55.502002c-3.358,-1.033 -8.649,-7.223 -8.649,-7.223l3.423,8.537l1.244,-3.12l3.982,1.806z",
    fill: "#F4B298",
    id: "svg_86"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.371132,
    y: 139.924058,
    width: 118.625,
    height: 24.696,
    fill: "#56548C",
    opacity: 0.6,
    id: "svg_87"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_88"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145.100481,
    cy: 149.977002,
    r: 9.595,
    fill: "url(#SVGID_00000101090154395486406760000010679221706530132613_)",
    id: "svg_89"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.709481,
    cy: 149.977002,
    r: 9.595,
    fill: "#38bff2",
    id: "svg_90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.108481,147.891002l-2.668,1.54l0,-1.751c0,-0.391 -0.317,-0.708 -0.708,-0.708l-4.595,0c-0.391,0 -0.708,0.317 -0.708,0.708l0,4.595c0,0.391 0.317,0.708 0.708,0.708l4.595,0c0.391,0 0.708,-0.317 0.708,-0.708l0,-1.751l2.668,1.54l0,-4.173z",
    fill: "#F8FAFB",
    id: "svg_91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "m114.647481,153.039002l-1.374,-1.4c0,0 -0.37,-0.342 -0.714,-0.132l-0.766,0.819l-0.217,0.262c-0.381,0.434 -1.44,-0.491 -1.44,-0.491c-0.792,-0.408 -2.559,-2.476 -2.559,-2.476c-0.87,-1.006 -0.381,-1.44 -0.381,-1.44l0.246,-0.245l0.842,-0.815c0,0 0.464,-0.272 -0.789,-1.333l-1.413,-1.442c0,0 -0.382,-0.354 -0.735,-0.137l-0.788,0.844l-0.246,0.244c-0.598,0.899 -0.326,2.422 -0.326,2.422c1.032,3.889 5.494,6.827 5.494,6.827c3.754,2.284 4.87,0.788 4.87,0.788l0.243,-0.208l0.819,-0.792c0,0.002 0.449,-0.264 -0.766,-1.295z",
    fill: "#F8FAFB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m267.449481,146.720002c0.238,0.546 0.475,1.117 0.713,1.687c0.048,0.071 0.071,0.143 0.095,0.214c0.76,1.71 -0.76,5.037 -4.775,6.676c-4.205,1.734 -11.142,2.138 -12.71,-1.164c-0.879,-1.901 -1.996,-4.276 -1.996,-4.276l-5.084,1.639c-0.428,-0.19 -0.855,-0.38 -1.235,-0.546c-6.628,-3.041 -8.648,-5.844 -12.021,-12.71c-0.048,-0.119 -0.119,-0.238 -0.166,-0.356c-0.843,-1.719 -1.493,-3.534 -1.913,-5.403c-0.374,-1.663 -1.107,-4.1 0.13,-5.543c0.557,-0.65 1.324,-1.079 2.08,-1.479c1.224,-0.648 2.469,-1.257 3.731,-1.827c1.842,-0.832 3.754,-1.587 5.766,-1.788c3.121,-0.311 6.304,0.776 8.776,2.708c1.511,1.182 2.768,2.666 3.756,4.306c0.428,0.711 1.566,4.342 2.692,3.965c1.281,-0.43 -0.88,-5.987 -0.88,-5.987c0.618,-1.117 1.829,-2.495 3.825,-1.14c2.685,1.829 2.471,6.415 1.14,8.315c0,0 3.207,7.84 6.438,8.79c-0.002,-0.002 0.735,1.78 1.638,3.919z",
    fill: "#FFC8AF",
    id: "svg_93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.745481,225.952002l6.51,0l12.354,0l0,3.991l-38.82,0l0,-3.991c1.307,0 2.043,0 2.043,0l17.913,0z",
    fill: "#BABCBE",
    id: "svg_94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.601481,210.319002l3.231,15.633c0,0 -0.737,0 -2.043,0l-11.071,-53.455c1.33,0 2.067,0 2.067,0l7.816,37.822z",
    fill: "#BABCBE",
    id: "svg_95"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.78950119018555,225.9519920349121 209.78950119018555,229.94298934936523 139.5844841003418,229.94298934936523 139.5844841003418,225.9519920349121 209.00449752807617,225.9519920349121 ",
    fill: "#CFD1D2",
    id: "svg_96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.717481,172.497002l11.071,53.455l-0.784,0l-69.42,0l-11.071,-53.455l68.708,0c0.57,0 1.069,0 1.496,0z",
    fill: "#CFD1D2",
    id: "svg_97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.764481,199.764002c0.882,2.647 -0.217,5.398 -2.456,6.144c-2.239,0.746 -4.769,-0.794 -5.651,-3.442c-0.883,-2.647 0.217,-5.398 2.456,-6.144c2.238,-0.746 4.769,0.795 5.651,3.442z",
    fill: "#F0F1F1",
    id: "svg_98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.348481,374.462002l0.071,1.212c-15.181,4.847 -23.259,0 -23.259,0s-7.009,-29.412 -12.425,-57.494l18.911,-32.121c0,0 2.019,-0.713 5.607,-1.806l11.095,90.209z",
    fill: "#050405",
    id: "svg_99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.419481,375.673002l0.927,16.013l-42.194,0c-15.847,0 18.008,-16.013 18.008,-16.013s8.078,4.847 23.259,0z",
    fill: "#626466",
    id: "svg_100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.240481,378.453002l-2.946,13.233l-41.196,0c-15.846,0 18.008,-16.013 18.008,-16.013s9.1,5.488 26.134,2.78z",
    fill: "#626466",
    id: "svg_101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.735481,318.179002l-35.494,60.273c-17.034,2.708 -26.133,-2.78 -26.133,-2.78s51.032,-96.837 56.116,-106.981c4.585,-9.194 55.831,-25.041 65.714,-28.034c10.501,0 25.587,1.235 36.112,5.345c6.724,2.59 11.57,6.367 12.212,11.713c-4.704,10.548 -15.443,13.97 -35.209,16.203c-20.907,2.352 -39.771,7.555 -48.798,10.335c-3.587,1.093 -5.607,1.806 -5.607,1.806l-18.913,32.12z",
    fill: "#050404",
    id: "svg_102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.846481,124.520002c0.597,2.654 1.037,5.355 1.369,8.087c0.073,0.597 0.42,10.141 0.594,10.192c-3.231,-0.95 -6.438,-8.79 -6.438,-8.79c1.33,-1.901 1.544,-6.486 -1.14,-8.315c-1.996,-1.354 -3.207,0.024 -3.825,1.14c0,0 2.162,5.559 0.879,5.987c-1.283,0.451 -2.827,-4.894 -4.728,-5.512c-1.662,-0.54 -3.401,-1.085 -4.912,-1.982c-1.645,-0.976 -2.673,-2.119 -4.788,-1.732c-1.402,0.257 -2.665,0.983 -3.937,1.628c-1.795,0.909 -3.663,1.673 -5.581,2.282c-2.044,0.649 -4.175,1.125 -6.316,1.016c-2.141,-0.109 -4.308,-0.85 -5.83,-2.36c-0.609,-0.604 -1.104,-1.316 -1.497,-2.078c-1.159,-2.243 -1.38,-5.091 -0.061,-7.244c0.964,-1.574 2.648,-2.621 4.434,-3.086c1.786,-0.465 3.673,-0.395 5.496,-0.107c0.62,-3.997 3.925,-7.435 7.895,-8.213c1.461,-0.286 3.167,-0.16 4.161,0.95c1.58,-1.627 3.704,-2.846 5.971,-2.878c2.268,-0.032 4.617,1.338 5.289,3.504c1.747,-0.788 3.911,-0.557 5.453,0.581c1.169,0.862 1.94,2.15 2.625,3.43c2.297,4.298 3.836,8.827 4.887,13.5z",
    fill: "#0e0e0f",
    id: "svg_103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.394481,212.624002l-5.844,0.642c-2.732,-12.734 -6.676,-31.146 -6.937,-32.453c5.226,12.995 12.781,31.811 12.781,31.811z",
    fill: "#A5B7C6",
    id: "svg_104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.254481,237.237002c0.142,8.862 -0.737,15.466 -2.993,20.479c-0.642,-5.346 -5.488,-9.123 -12.212,-11.713c1.877,-4.063 2.518,-9.812 2.138,-16.274c4.205,0.119 8.577,0.285 12.52,0.166c0.238,2.495 0.428,4.966 0.547,7.342z",
    fill: "#A5B7C6",
    id: "svg_105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.770481,229.587002c0.808,0.024 1.616,0.048 2.4,0.071c0.998,0.024 1.996,0.048 3.017,0.071c0.38,6.462 -0.261,12.211 -2.138,16.274c-10.525,-4.11 -25.611,-5.345 -36.112,-5.345c-0.618,-2.091 -2.067,-6.866 -3.801,-12.806c4.063,0.475 7.745,-0.95 7.745,-0.95s16.131,2.233 28.889,2.685z",
    fill: "#C3D3DD",
    id: "svg_106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.612481,180.812002c0.261,1.307 4.205,19.719 6.937,32.453l5.844,-0.642c0.001,0.001 -7.554,-18.815 -12.781,-31.811zm22.095,49.084c-3.944,0.119 -8.315,-0.048 -12.52,-0.166c-1.022,-0.024 -2.019,-0.048 -3.017,-0.071c-0.784,-0.024 -1.592,-0.047 -2.4,-0.071c0.451,-8.648 -3.136,-14.421 -3.944,-15.585l-22.665,2.494c0,0 -8.41,-2.186 -14.231,-2.898c-4.015,-13.518 -7.935,-26.799 -7.935,-26.799l-11.024,28.604c-1.853,5.013 -3.374,8.363 -5.227,10.548l-17.913,0l-3.231,-15.633c4.11,-0.475 6.747,-0.76 6.747,-0.76c3.231,-11.689 12.354,-40.483 14.088,-47.112c1.331,-4.989 5.963,-8.862 13.019,-11.499c0.38,0.166 0.808,0.356 1.235,0.546l5.084,-1.639c0,0 1.117,2.376 1.996,4.276c1.568,3.302 8.505,2.898 12.71,1.164c4.015,-1.639 5.536,-4.965 4.775,-6.676c-0.024,-0.071 -0.047,-0.143 -0.095,-0.214c-0.238,-0.57 -0.475,-1.14 -0.713,-1.687c11.784,-0.784 23.948,-0.38 30.054,3.706l0.047,-0.071c12.069,7.246 29.958,64.692 29.151,72.889c-0.496,4.967 -6.459,6.368 -13.991,6.654z",
    fill: "#c3d3dd",
    id: "svg_107"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.56748580932617,157.35400009155273 253.05646896362305,235.0979881286621 258.5024833679199,241.65200424194336 264.7084770202637,234.93398666381836 256.3854789733887,157.1460075378418 ",
    fill: "#040405",
    id: "svg_108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.930481,213.598002c5.821,0.713 14.231,2.898 14.231,2.898l22.665,-2.494c0.808,1.164 4.395,6.937 3.944,15.585c-12.758,-0.451 -28.889,-2.685 -28.889,-2.685s-3.682,1.426 -7.745,0.95c-0.57,-0.071 -1.117,-0.166 -1.687,-0.309c-4.633,-1.164 -6.462,-4.039 -7.698,-4.086c-1.259,-0.071 -6.557,0.879 -9.812,1.687c-0.974,0.261 -1.901,0.356 -2.685,0.356c-1.829,0 -2.898,-0.618 -2.21,-1.592c0.998,-1.378 2.661,-4.514 4.419,-5.464c1.782,-0.95 7.769,-4.918 11.974,-5.084c0.928,-0.047 2.139,0.048 3.493,0.238z",
    fill: "#FFC8AF",
    id: "svg_109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.287481,154.260002l7.865,4.404c0,0 2.965,-2.323 4.915,-4.915c3.482,-4.629 3.809,-7.355 3.809,-7.355l-5.585,-2.432c0.001,-0.001 -5.597,6.734 -11.004,10.298z",
    fill: "#DCE8EF",
    id: "svg_110"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.07548141479492,154.32099533081055 248.8974723815918,158.66399765014648 246.63047409057617,150.5470085144043 248.77549362182617,149.85599899291992 ",
    fill: "#DCE8EF",
    id: "svg_111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.075481,154.321002l2.212,-0.062l3.383,1.894c0,0 -1.581,1.24 -4.161,1.199s-3.264,-1.13 -3.264,-1.13l1.83,-1.901z",
    fill: "url(#SVGID_00000073679669538448038670000008265385035722506149_)",
    id: "svg_112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.442481,214.484002c0.12,-0.707 5.281,-1.934 7.37,-1.136c2.089,0.798 3.871,8.457 4.178,11.017s0.43,4.503 0,5.221c-0.43,0.719 -7.017,0.716 -7.963,-0.235c-0.946,-0.951 0.344,-2.523 -0.578,-7.758s-3.007,-7.109 -3.007,-7.109z",
    fill: "#DCE8EF",
    id: "svg_113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_114"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.088481,
    y: 240.064002,
    width: 7.626,
    height: 151.622,
    fill: "#CFD1D2",
    id: "svg_115"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.594481,
    y: 240.064002,
    width: 7.602,
    height: 151.622,
    fill: "#CFD1D2",
    id: "svg_116"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.088481,
    y: 240.064002,
    width: 7.626,
    height: 8.138,
    fill: "#BABCBE",
    id: "svg_117"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.594481,
    y: 240.064002,
    width: 7.602,
    height: 8.138,
    fill: "#BABCBE",
    id: "svg_118"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.7964897155762,229.94298934936523 359.7964897155762,240.06399154663086 347.8454704284668,240.06399154663086 341.6464958190918,240.06399154663086 103.06748580932617,240.06399154663086 96.84948348999023,240.06399154663086 84.9174919128418,240.06399154663086 84.9174919128418,229.94298934936523 232.7874870300293,229.94298934936523 264.4384880065918,229.94298934936523 321.6764945983887,229.94298934936523 ",
    fill: "#F0F1F1",
    id: "svg_119"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m244.320481,134.599002c0,1.123 -0.91,2.033 -2.033,2.033c-1.123,0 -2.033,-0.91 -2.033,-2.033c0,-1.123 0.91,-2.033 2.033,-2.033c1.123,0 2.033,0.91 2.033,2.033z",
    fill: "#112B46",
    id: "svg_121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.093481,137.420002c0,0.984 -0.798,1.782 -1.782,1.782s-1.782,-0.798 -1.782,-1.782c0,-0.984 0.798,-1.782 1.782,-1.782s1.782,0.798 1.782,1.782z",
    fill: "#112B46",
    id: "svg_122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.001481,142.799002c0,0 2.622,-1.299 3.072,-1.34c0.451,-0.041 -0.041,0.755 -1.106,1.34c-1.065,0.586 -1.966,0 -1.966,0z",
    fill: "#F4B298",
    id: "svg_123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.360481,148.429002c0,0 1.775,-0.887 2.07,-0.898c0.295,-0.011 0.036,0.796 -0.688,1.201c-0.724,0.405 -1.382,-0.303 -1.382,-0.303z",
    fill: "#F4B298",
    id: "svg_124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.569481,129.834002c0,0 -4.288,1.972 -5.017,2.017c-0.729,0.045 0.101,-1.215 1.846,-2.109c1.745,-0.894 3.171,0.092 3.171,0.092z",
    fill: "#56548C",
    id: "svg_125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.530481,135.515002c0,0 3.82,-1.223 4.254,-1.626c0.434,-0.402 -0.957,-0.754 -2.579,-0.318c-1.623,0.437 -1.675,1.944 -1.675,1.944z",
    fill: "#56548C",
    id: "svg_126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.914481,145.938002c0,0 3.809,-1.266 7.66,-4.215c0,0 0.986,1.696 0.226,3.106c-0.76,1.411 -3.6,3.055 -5.271,2.93c-1.67,-0.124 -2.615,-1.821 -2.615,-1.821z",
    fill: "#EC827D",
    id: "svg_127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.574481,141.723002c-3.851,2.949 -7.66,4.215 -7.66,4.215s0.132,0.235 0.382,0.536c2.299,-0.53 5.035,-1.689 7.631,-3.878c-0.152,-0.514 -0.353,-0.873 -0.353,-0.873z",
    fill: "#F9FBFC",
    id: "svg_128"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m259.371481,134.009002c-1.176,1.388 -1.628,1.538 -1.628,1.538s1.015,1.365 1.852,1.212c0.845,-0.154 -0.224,-2.75 -0.224,-2.75z",
    fill: "#F4B298",
    id: "svg_129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.703481,127.935002c0.002,-0.208 0.019,-0.429 0.142,-0.596c0.118,-0.161 0.315,-0.245 0.51,-0.287c0.795,-0.171 1.634,0.28 2.09,0.953c0.456,0.673 0.579,1.523 0.536,2.335c-0.021,0.392 -0.08,0.79 -0.257,1.14c-0.281,0.559 -0.866,0.953 -1.49,1.003c-0.091,0.007 -0.186,0.007 -0.269,-0.032c-0.09,-0.043 -0.153,-0.126 -0.21,-0.208c-0.242,-0.347 -0.45,-0.772 -0.335,-1.179c0.063,-0.226 0.222,-0.423 0.247,-0.656c0.062,-0.573 -0.504,-0.472 -0.737,-0.738c-0.282,-0.318 -0.232,-1.334 -0.227,-1.735z",
    fill: "#F4B298",
    id: "svg_130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.775481,149.856002c2.58,-0.941 3.194,-0.999 3.194,-0.999l-1.95,2.291l-1.244,-1.292z",
    fill: "#F4B298",
    id: "svg_131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutor);
export default __webpack_public_path__ + "static/media/tutor.55487ee6fbac139246221457d4dd235c.svg";
export { ForwardRef as ReactComponent };